<template>
  <div class="animated fadeIn">
    <Forms ref="frmEmailEnvio"
      :title="'CADASTRO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      :disabledKeyUpEnter="true"
      :isModal="isModal"
      v-on:Clear="onClear"
      v-on:Back="$emit('Back')"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label ><small v-if="form.emailHost.required" class="text-danger">*</small> Host:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o nome do Host'"
                          v-model="form.emailHost.value"
                          :size="form.emailHost.maxlength"
                          :required="form.emailHost.required"
                          :state="form.emailHost.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtName"><small v-if="form.emailPort.required" class="text-danger">*</small> Porta:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite a porta usada pelo Host'"
                          v-model="form.emailPort.value"
                          :size="form.emailPort.maxlength"
                          :required="form.emailPort.required"
                          :state="form.emailPort.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtName"><small v-if="form.safeConnection.required" class="text-danger">*</small> Conexão segura: </label>
          <div class="input-group">
            <b-form-select v-model="form.safeConnection.value" :options="form.safeConnection.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtName"><small v-if="form.envioAutenticado.required" class="text-danger">*</small> Envio Autenticado ?</label>
          <div class="input-group">
            <b-form-checkbox v-model="form.envioAutenticado.value" checked-value=true unchecked-value=false>
              <span style="padding-top: 3px; display: block;">Sim</span>
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-3">
          <label for="txtName"><small v-if="form.emailFrom.required" class="text-danger">*</small> Email:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o email'"
                          v-model="form.emailFrom.value"
                          :size="form.emailFrom.maxlength"
                          :required="form.emailFrom.required"
                          :state="form.emailFrom.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtName"><small v-if="form.replyTo.required" class="text-danger">*</small> Respostas do email:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o email para Respostas'"
                          v-model="form.replyTo.value"
                          :size="form.replyTo.maxlength"
                          :required="form.replyTo.required"
                          :state="form.replyTo.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtName"><small v-if="form.emailUser.required" class="text-danger">*</small> Usuário:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o usuário'"
                          v-model="form.emailUser.value"
                          :size="form.emailUser.maxlength"
                          :required="form.emailUser.required"
                          :state="form.emailUser.state"
                          :disabled="!isEnvioAutenticado"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtName"><small v-if="form.emailPassword.required" class="text-danger">*</small> Senha:</label>
          <div class="input-group">
            <b-form-input type="password"
                          :placeholder="'Digite a senha'"
                          v-model="form.emailPassword.value"
                          :size="form.emailPassword.maxlength"
                          :required="form.emailPassword.required"
                          :state="form.emailPassword.state"
                          :disabled="!isEnvioAutenticado"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-2 pt-2">
          <button type="button" class="btn rounded-4 btn-third w-100" v-on:click="onTest">
            Testar
          </button>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
/* https://github.com/hinesboy/mavonEditor/blob/master/README-EN.md */
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import EmailEnvioRepository from '@/shared/http/repositories/configurations/emailenvio.js'
import EmailEnvioModel from '@/shared/models/configurations/emailenviomodel.js'
import EmailEnvioForms from './emailenvioadd-form.js'

export default {
  name: 'CampanhaRedeSocialAdd',
  mixins: [ActionsForm],
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: EmailEnvioModel,
      form: EmailEnvioForms,
      toolbars: {
        bold: false,
        italic: false,
        header: false,
        underline: false,
        strikethrough: false,
        mark: false,
        superscript: false,
        subscript: false,
        quote: false,
        ol: false,
        ul: false,
        link: false,
        imagelink: false,
        code: false,
        table: false,
        fullscreen: false,
        readmodel: false,
        htmlcode: false,
        help: false,
        undo: false,
        redo: false,
        trash: false,
        save: false,
        navigation: false,
        alignleft: false,
        aligncenter: false,
        alignright: false,
        subfield: false,
        preview: false
      },
      customToolbar: {
        bold: {
          name: 'Negrito',
          icon: 'fa-mavon-bold text-third',
          prefix: '<b>',
          subfix: '</b>',
          str: ''
        },
        italic: {
          name: 'Itálico',
          icon: 'fa-mavon-italic text-third',
          prefix: '<i>',
          subfix: '</i>',
          str: ''
        },
        header: {
          name: 'Cabeçalho',
          icon: 'fa-mavon-header text-third',
          prefix: '',
          subfix: '',
          str: '',
          timer: null,
          dropdownOpen: false,
          items: [
            {
              name: 'Cabeçalho 1',
              prefix: '<h1>',
              subfix: '</h1>',
              str: ''
            },
            {
              name: 'Cabeçalho 2',
              prefix: '<h2>',
              subfix: '</h2>',
              str: ''
            },
            {
              name: 'Cabeçalho 3',
              prefix: '<h3>',
              subfix: '</h3>',
              str: ''
            },
            {
              name: 'Cabeçalho 4',
              prefix: '<h4>',
              subfix: '</h4>',
              str: ''
            },
            {
              name: 'Cabeçalho 5',
              prefix: '<h5>',
              subfix: '</h5>',
              str: ''
            },
            {
              name: 'Cabeçalho 6',
              prefix: '<h6>',
              subfix: '</h6>',
              str: ''
            }
          ]
        },
        underline: {
          name: 'Sublinhar',
          icon: 'fa-mavon-underline text-third',
          prefix: '<ins>',
          subfix: '</ins>',
          str: ''
        },
        strikethrough: {
          name: 'Tachar',
          icon: 'fa-mavon-strikethrough text-third',
          prefix: '<del>',
          subfix: '</del>',
          str: ''
        },
        variables: {
          name: 'Variáveis',
          icon: 'fa-address-card text-third',
          prefix: '',
          subfix: '',
          str: '',
          timer: null,
          dropdownOpen: false,
          items: [
            {
              name: 'Nome',
              prefix: '@',
              subfix: '@',
              str: 'Nome'
            },
            {
              name: 'Email',
              prefix: '@',
              subfix: '@',
              str: 'Email'
            },
            {
              name: 'Telefone',
              prefix: '@',
              subfix: '@',
              str: 'Telefone'
            },
            {
              name: 'Link de Conversão',
              prefix: '@',
              subfix: '@',
              str: 'CTA'
            }
          ]
        },
        undo: {
          name: 'Desfazer (CTRL+Z)',
          icon: 'fa-mavon-undo text-third',
          prefix: '',
          subfix: '',
          str: ''
        },
        redo: {
          name: 'Resfazer (CTRL+Y)',
          icon: 'fa-mavon-repeat text-third',
          prefix: '',
          subfix: '',
          str: ''
        },
        trash: {
          name: 'Limpar (CTRL+BREAKSPACE)',
          icon: 'fa-trash-alt text-third',
          prefix: '',
          subfix: '',
          str: ''
        }
      }
    }
  },
  watch: {
    'form.boardId.value': function (value) {
      if (value) {
        if (this.form.boardColumnId.options.length > 0) {
          this.form.boardColumnId.options = []
          this.form.boardColumnId.value = null
        }
        this.onChangeBoard(value)
      } else {
        this.form.boardColumnId.options = []
        this.form.boardColumnId.value = null
      }
    }
  },
  computed: {
    isEnvioAutenticado () {
      return this.form.envioAutenticado.value
    }
  },
  methods: {
    mouseLeaveDropdown (option) {
      option.timer = setTimeout(function () {
        option.dropdownOpen = false
      }, 200)
    },
    mouseEnterDropdown (option) {
      clearTimeout(option.timer)
      option.dropdownOpen = true
    },
    onLoad () {
    },
    onEdit (obj) {
      if (obj) {
        loading.push()
        Tools.SetValueInForm(this.form, this.data, obj)
        this.form.safeConnection.value = obj.safeConnection
        loading.close()
      }
    },
    onCreate () {
      loading.push()
      EmailEnvioRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      EmailEnvioRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onTest () {
      loading.push()
      Tools.SetValueToSave(this.form, this.data)
      EmailEnvioRepository.Test(this.data)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
          }
          loading.close()
        })
        .catch(this.onException)
    }
  }
}
</script>

<style scoped>
.mavonEditor {
  border: solid 1px #ccc;
  min-width: 100%;
  min-height: 543px;
  max-height: 543px;
  overflow: scroll;
}
.v-note-wrapper.shadow {
  border: solid 1px #ccc;
}
.markdown-body>:first-child {
  background-color: #eceff1 !important;
  border-bottom: solid 1px #cfd8dc;
}
.v-note-wrapper .v-note-op .v-left-item .op-icon,
.v-note-wrapper .v-note-op .v-right-item .op-icon {
  color: #006a5b !important;
}
.v-note-wrapper .v-note-op .v-left-item .op-icon.selected,
.v-note-wrapper .v-note-op .v-right-item .op-icon.selected {
  color: #006a5b !important;
  font-weight: 800;
}

.v-note-wrapper .v-note-op .v-left-item .op-icon:hover,
.v-note-wrapper .v-note-op .v-right-item .op-icon:hover {
  color: #005c50 !important;
  font-weight: 800;
}

.v-note-wrapper .v-note-op .v-left-item .op-icon button, .v-note-wrapper .v-note-op .v-right-item .op-icon button {
  color: #006a5b;
}
button.op-icon {
  color: #006a5b !important;
}
.nxbr-toolbar {
  background-color: #eceff1 !important;
  border-top: solid 1px #cfd8dc;
  border-left: solid 1px #cfd8dc;
  border-right: solid 1px #cfd8dc;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/email/components/add/emailenvioadd.vue